// 流程节点发光图标（线描 SVG，stroke 风格，供生产安全/工艺流程页共用）
<template>
  <svg class="flow-icon" :viewBox="'0 0 24 24'" fill="none" aria-hidden="true">
    <template v-if="name === 'snow'">
      <path d="M12 2v20M4 6l16 12M20 6L4 18" /><path d="M9 4l3 2 3-2M9 20l3-2 3 2M3.5 9.5L7 9l1-3.2M20.5 14.5L17 15l-1 3.2M20.5 9.5L17 9l-1-3.2M3.5 14.5L7 15l1 3.2" />
    </template>
    <template v-else-if="name === 'molecule'">
      <circle cx="7" cy="7" r="2.6" /><circle cx="17" cy="7" r="2.6" /><circle cx="12" cy="16" r="2.6" />
      <path d="M8.8 9.4L11 13.8M15.2 9.4L13 13.8M9.6 7h4.8" />
    </template>
    <template v-else-if="name === 'rings'">
      <circle cx="8.5" cy="9" r="3.4" /><circle cx="15.5" cy="9" r="3.4" /><circle cx="12" cy="15" r="3.4" />
    </template>
    <template v-else-if="name === 'waves'">
      <path d="M3 8c3-2.4 6-2.4 9 0s6 2.4 9 0" /><path d="M3 13c3-2.4 6-2.4 9 0s6 2.4 9 0" /><path d="M3 18c3-2.4 6-2.4 9 0s6 2.4 9 0" />
    </template>
    <template v-else-if="name === 'box'">
      <path d="M12 3l8 4.2v9.6L12 21l-8-4.2V7.2L12 3z" /><path d="M4 7.2l8 4.2 8-4.2M12 11.4V21" /><path d="M8 5.1l8 4.2" />
    </template>
    <template v-else-if="name === 'hex'">
      <path d="M12 3l7 4v10l-7 4-7-4V7l7-4z" /><circle cx="12" cy="12" r="3" /><circle cx="12" cy="12" r="0.8" />
    </template>
    <template v-else-if="name === 'ringbreak'">
      <circle cx="12" cy="12" r="7" /><path d="M12 5a7 7 0 0 1 6.6 4.6" stroke-width="2.6" /><circle cx="12" cy="12" r="2.4" />
    </template>
    <template v-else-if="name === 'honeycomb'">
      <path d="M8 4.5L11.5 6.5v4L8 12.5L4.5 10.5v-4L8 4.5z" /><path d="M16 4.5L19.5 6.5v4L16 12.5l-3.5-2v-4L16 4.5z" /><path d="M12 11.5l3.5 2v4L12 19.5l-3.5-2v-4l3.5-2z" />
    </template>
    <template v-else-if="name === 'grid'">
      <rect x="4" y="4" width="7" height="7" rx="1" /><rect x="13" y="4" width="7" height="7" rx="1" /><rect x="4" y="13" width="7" height="7" rx="1" /><rect x="13" y="13" width="7" height="7" rx="1" />
    </template>
    <template v-else-if="name === 'scatter'">
      <circle cx="12" cy="6" r="1.6" /><circle cx="6.5" cy="10" r="1.6" /><circle cx="17.5" cy="10" r="1.6" /><circle cx="9" cy="15.5" r="1.6" /><circle cx="15" cy="15.5" r="1.6" /><circle cx="12" cy="20" r="1.2" />
    </template>
    <template v-else-if="name === 'shield'">
      <path d="M12 3l7 2.6v5.6c0 4.4-3 8-7 9.8-4-1.8-7-5.4-7-9.8V5.6L12 3z" /><circle cx="12" cy="10.5" r="2.2" /><path d="M12 12.7v3" />
    </template>
    <template v-else-if="name === 'sun'">
      <circle cx="12" cy="13" r="4.2" /><path d="M12 4.5v2.4M4.5 13h2.4M17.1 13h2.4M6.7 7.7l1.7 1.7M17.3 7.7l-1.7 1.7M5.5 18.5h13" /><path d="M4 21h16" />
    </template>
    <template v-else-if="name === 'thumb'">
      <path d="M7 11l3.5-7c1.6 0 2.5 1 2.5 2.4V10h5c1.2 0 2 1 1.8 2.1l-1.2 6A2 2 0 0 1 16.6 20H7" /><rect x="3" y="11" width="4" height="9" rx="1" />
    </template>
    <template v-else-if="name === 'check'">
      <path d="M4.5 12.5l5 5L20 6.5" stroke-width="2.6" />
    </template>
    <template v-else>
      <circle cx="12" cy="12" r="7" />
    </template>
  </svg>
</template>

<script>
export default {
  name: 'FlowIcon',
  props: {
    name: { type: String, default: '' },
  },
};
</script>

<style lang="less" scoped>
.flow-icon {
  width: 100%;
  height: 100%;
  stroke: #9beaff;
  stroke-width: 1.5;
  stroke-linecap: round;
  stroke-linejoin: round;
  filter: drop-shadow(0 0 8px rgba(60, 224, 255, 0.85));
}
</style>
